import React from "react";
import "./App.css";
import ChatBody from "./components/chatBody/ChatBody";

function App() {
  return (
    <div className="__main">
      <ChatBody />
    </div>
  );
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js